// Client d'analyse : Web Worker si disponible, sinon exécution directe (même moteur, même résultat).
import { analyzePassword } from "./engine";

let worker = null;
let seq = 0;
const pending = new Map();

function getWorker() {
  if (worker !== null) return worker;
  try {
    worker = new Worker(new URL("./zxcvbn.worker.js", import.meta.url));
    worker.onmessage = ({ data }) => {
      const p = pending.get(data.id);
      if (!p) return;
      pending.delete(data.id);
      data.error ? p.reject(new Error("analysis")) : p.resolve(data.result);
    };
  } catch (e) {
    worker = false;
  }
  return worker;
}

export function analyze(password, ctx, lang) {
  const w = getWorker();
  if (!w) return analyzePassword(password, ctx, lang);
  const id = ++seq;
  return new Promise((resolve, reject) => {
    pending.set(id, { resolve, reject });
    w.postMessage({ id, password, ctx, lang });
  });
}
